import { UserRole } from '@app/types'
import { Badge, BADGE_COLOR_ORDER } from '@/components/ui/badge'
import { DOCUMENT_ROLE_LABELS_MAP } from '../../../documents.constants'
import type { DocumentRoleOption } from '../../../hooks/useDocumentRoleOptions'

const ADMIN_LABEL = DOCUMENT_ROLE_LABELS_MAP[UserRole.ADMIN]

type PermissionsSummaryProps = {
  roleOptions: DocumentRoleOption[]
  roleIds: string[]
  isPrivate: boolean
}

export const PermissionsSummary = ({
  roleOptions,
  roleIds,
  isPrivate,
}: PermissionsSummaryProps) => {
  // Colour keyed by fixed list position, not selection order, so a role's colour stays stable.
  const allRoleIds = ['you', 'admin', ...roleOptions.map((role) => role.id)]
  const roleBadgeColor = (roleId: string) => {
    const index = allRoleIds.indexOf(roleId)
    return BADGE_COLOR_ORDER[(index < 0 ? 0 : index) % BADGE_COLOR_ORDER.length]
  }

  return (
    <div className="rounded-md border bg-slate-50 p-3">
      <p className="text-xs font-medium text-muted-foreground mb-1.5">WHO CAN SEE THIS</p>
      <div className="flex flex-wrap gap-1.5">
        <Badge variant={roleBadgeColor('you')} size="sm">
          You
        </Badge>
        <Badge variant={roleBadgeColor('admin')} size="sm">
          {ADMIN_LABEL}
        </Badge>
        {isPrivate
          ? null
          : roleIds.map((roleId) => (
              <Badge key={roleId} variant={roleBadgeColor(roleId)} size="sm">
                {roleOptions.find((r) => r.id === roleId)?.label ?? roleId}
              </Badge>
            ))}
      </div>
    </div>
  )
}
